
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/var/canvas/ui/shared/groups/jst/_selfSignupHelp.handlebars";
import "/var/canvas/ui/shared/groups/jst/_autoLeadershipControls.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/groups/jst/groupCategoryEdit';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  return " dotted-separator";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <fieldset class=\"pad-box dotted-separator\">\n    <div class=\"control-group\">\n      <label class=\"checkbox\" for=\"enable_self_signup-";
  if (helper = helpers.uniqid) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqid); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'uniqid': (true),
    'class': ("self-signup-toggle")
  },data:data},helper ? helper.call(depth0, "enable_self_signup", options) : helperMissing.call(depth0, "checkbox", "enable_self_signup", options)))
    + "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_edit")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_edit.allow_self_signup", "Allow self sign-up", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_edit.allow_self_signup", "Allow self sign-up", options)))
    + "\n      </label>\n      ";
  stack1 = self.invokePartial(partials['ui/shared/groups/jst/_selfSignupHelp.handlebars'], 'ui/shared/groups/jst/_selfSignupHelp.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"self-signup-controls\">\n      <div class=\"control-group\">\n        <label class=\"checkbox\" for=\"restrict_self_signup-";
  if (helper = helpers.uniqid) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqid); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n          "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'uniqid': (true)
  },data:data},helper ? helper.call(depth0, "restrict_self_signup", options) : helperMissing.call(depth0, "checkbox", "restrict_self_signup", options)))
    + "\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_edit")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_edit.require_same_section", "Require group members to be in the same section", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_edit.require_same_section", "Require group members to be in the same section", options)))
    + "\n        </label>\n      </div>\n      <div class=\"control-group\">\n        <div id=\"group_limit_input_container_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-value=";
  if (helper = helpers.group_limit) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.group_limit); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "></div>\n        <div>\n          <strong>\n            <em>\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_edit")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_edit.group_limit_override", "Changing this will override any individually set group limits", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_edit.group_limit_override", "Changing this will override any individually set group limits", options)))
    + "\n            </em>\n          </strong>\n        </div>\n      </div>\n      <div id=\"category_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_self_signup_end_at_picker\"></div>\n    </div>\n  </fieldset>\n  ";
  stack1 = self.invokePartial(partials['ui/shared/groups/jst/_autoLeadershipControls.handlebars'], 'ui/shared/groups/jst/_autoLeadershipControls.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }

  buffer += "<div class=\"form-dialog-content pad-box form-inline group-category-edit\">\n  <fieldset class=\"pad-box";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.allow_self_signup), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    <div style=\"display:flex;flex-direction:row;align-items:center\">\n      <label>\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_edit")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_edit.group_set_name", "Group Set Name", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_edit.group_set_name", "Group Set Name", options)))
    + " &nbsp;\n      </label>\n      <div id=\"group_set_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_name_input_container\" data-value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></div>\n    </div>\n  </fieldset>\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.allow_self_signup), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n<div class=\"form-controls\">\n  <button type=\"button\" class=\"btn dialog_closer\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_edit")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_edit.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_edit.cancel", "Cancel", options)))
    + "</button>\n  <button type=\"submit\" class=\"btn btn-primary\" data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_edit")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_edit.saving", "Saving...", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_edit.saving", "Saving...", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_edit")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_edit.save", "Save", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_edit.save", "Save", options)))
    + "</button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  